export class BfaConstants {
	public static readonly DEFAULT_MAX_NOTIFICATIONS_DAYS_TO_SHOW: number = 14;

	public static readonly DEFAULT_DECIMAL_PLACES: number = 2;

	public static readonly ASSET_TICKER_IDENTIFIER_TYPE: string = 'TICKER';
	public static readonly ASSET_ISIN_IDENTIFIER_TYPE: string = 'ISIN';
}
